import { Suspense } from 'react';
import { useLoaderData,json,defer,Await } from 'react-router-dom';

import EventsList from '../components/EventsList';

function EventsPage() {
  const {events}=useLoaderData();
  
  return (
    <>
    <Suspense fallback={<p style={{textAlign:'center'}}>Loading...</p>}>
    <Await resolve={events}>
      {(loadedEvents)=><EventsList events={loadedEvents} />}
    </Await>
    </Suspense>
    </>
  );
}

export default EventsPage;

async function loadEvents(){
  const response = await fetch('https://newsletter-app-9e353b94f1d7.herokuapp.com/events');

    if (!response.ok) {
      return json({message:'Could not fetch event!'},{status:500});
      // throw new Response(JSON.stringify({message:'Could not fetch event!'}),{status:500});
    } else {
      const resData=await response.json();
      return resData.events;
    }
}

export function loader() {
    return defer({
      events:loadEvents()
    });
}